"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactEmotion = require("react-emotion");

var _styleConsts = require("../../utils/styleConsts");

var headerCellStyle = function headerCellStyle(theme, canBeSorted, sorted, filtered, reverse, bordered) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("&:first-child{padding-left:10px;}.IconAngleDown{margin-left:6px;fill:", theme.color.dark.sapphire, ";vertical-align:baseline;opacity:0;transition:opacity 0.15s;", sorted && "\n      fill: ".concat(theme.color.dark.sapphire, " !important;\n      opacity: 1;\n      \n      ").concat(reverse && "\n        transform: rotate(180deg);\n      ", "\n    "), "}&:hover .IconAngleDown{opacity:1;}padding:16px 10px;text-transform:uppercase;color:", theme.color.dark.iron, ";letter-spacing:0.9px;font-size:", _styleConsts.font.size.small, ";font-weight:", _styleConsts.font.weight.bold, ";line-height:16px;height:20px;box-sizing:border-box;", bordered ?
    /*#__PURE__*/
    (0, _reactEmotion.css)("border:1px solid ", theme.color.dark.venus, ";") :
    /*#__PURE__*/
    (0, _reactEmotion.css)("border-bottom:1px solid ", theme.color.dark.venus, ";"), "\n  \n  ", !!canBeSorted && "\n    cursor: pointer;\n  ", "\n\n  ", sorted && "\n    color: ".concat(theme.color.dark.copper, ";\n    padding-bottom: 15px;\n    border-bottom: 2px solid ").concat(theme.color.dark.mercury, ";\n  "), "\n  \n  ", filtered && "\n    color: ".concat(theme.color.dark.copper, ";\n  "))
  );
};

var _default = headerCellStyle;
exports.default = _default;